import "./Card.scss";
import arrowBenefitsCard from "../../assets/images/arrowBenefitsCard.svg";

interface CardProps {
  title: string;
  text: string;
}
const Card = ({ title, text }: CardProps) => {
  return (
    <div className="card-container">
      <div className="card-title">{title}</div>
      <div className="card-text">{text}</div>
      <img
        src={arrowBenefitsCard}
        alt="arrow"
        className="arrow-benefits-card"
      />
    </div>
  );
};
export default Card;
